import axios from "axios";
import React, { useState } from "react";
import { Button, Col, Form, InputGroup, Modal, Row } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const ReopenTaskModal = ({ show, close, data }) => {

    const loginUserData = useSelector((state) => state.loginData.userData);

    const [remark, setRemark] = useState("");
    const [startDate, setStartDate] = useState(
        data?.proposedStartDate
            ? new Date(data?.proposedStartDate)
                .toISOString()
                .split("T")[0]
            : ""
    );

    const [endDate, setEndDate] = useState(
        data?.proposedEndDate
            ? new Date(data?.proposedEndDate)
                .toISOString()
                .split("T")[0]
            : ""
    );

    const [hours, setHours] = useState(
        data?.initialEstimateHr || ""
    );

    const [minutes, setMinutes] = useState(
        data?.initialEstimateMinutes || ""
    );
    const [errors, setErrors] = useState({});

    // for validation handler function
    const handleValidate = () => {
        let newErrors = {};

        if (!remark) {
            newErrors.remark = "Required Field";
        }

        if (!startDate) {
            newErrors.startDate = "Required Field";
        }

        if (!endDate) {
            newErrors.endDate = "Required Field";
        }

        if (!hours && hours !== 0) {
            newErrors.hours = "Required Field";
        }

        if (!minutes && minutes !== 0) {
            newErrors.minutes = "Required Field";
        }

        if (
            Number(hours) === 0 &&
            Number(minutes) === 0
        ) {
            newErrors.minutes = "00 hours and 00 minutes are not allowed";
        }

        if (
            Number(minutes) < 0 ||
            Number(minutes) > 59
        ) {
            newErrors.minutes = "Minutes should be between 0 and 59";
        }

        if (
            startDate &&
            endDate &&
            new Date(startDate) > new Date(endDate)
        ) {
            newErrors.endDate = "End date should be greater than Start date";
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // for handler submit function
    const handleSubmit = async () => {
        if (!handleValidate()) {
            return;
        }
        const payload = {
            taskId: data?.taskId,
            updatedBy: `${loginUserData?.firstName} ${loginUserData?.lastName}`,
            empId: data?.empId,
            taskName: data?.taskName,
            department_id: data?.department_id,
            departmentName: data?.departmentName,
            subDepartmentId: data?.subDepartmentId,
            subDepartmentName: data?.subDepartmentName,
            taskDepartmentId: data?.taskDepartmentId,
            taskDepartmentName: data?.taskDepartmentName,
            taskDescription: data?.taskDescription,
            taskPriority: data?.taskPriority,
            projectId: data?.projectId,
            projectName: data?.projectName,
            AssignTask: "",
            assignBy_id: data?.assignBy_id,
            assignBy_Name: data?.assignBy_Name,
            assignTo_Department: data?.assignTo_Department || data?.departmentName,
            resource_id: data?.resource_id,
            resourceName: data?.resourceName,
            categoryOfName: data?.categoryOfName || "",
            category_id: data?.category_id || "",
            proposedStartDate: new Date(startDate).toISOString(),
            proposedEndDate: new Date(endDate).toISOString(),
            initialEstimateHr: Number(hours),
            initialEstimateMinutes: Number(minutes),
            estimateHr: Number(hours) + Number(minutes) / 60,
            reopenRemark: remark,
            overDueTaskTime: data?.overDueTaskTime || 0,
            isTaskAssigned: data?.isTaskAssigned || false,
            isSelfTaskAssigned: data?.isSelfTaskAssigned || false,
            isOtherDeptTaskAssigned: data?.isOtherDeptTaskAssigned || false,
            otherProjectName: data?.otherProjectName || ""
        };

        console.log("payload", payload)

        try {
            await axios.post(process.env.REACT_APP_BASE_URL + "/task/reopenTask", payload);
            toast.success("Task reopened successfully");
            close();

        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
        }
    };

    return (
        <Modal show={show} onHide={close} size="lg" centered backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>
                    Reopen Task
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>

                {/* Reopen Reason */}
                <Row className="mb-4">
                    <Col md={12}>
                        <Form.Group>
                            <Form.Label className="fw-bold">
                                Reopen Reason
                                <span className="requiredfield">*</span>
                            </Form.Label>

                            <Form.Control
                                as="textarea"
                                rows={3}
                                value={remark}
                                onChange={(e) => setRemark(e.target.value)}
                                placeholder="Enter reopen reason"
                            />
                            {errors.remark && (
                                <p className="errMsg">
                                    <Icon.ExclamationTriangle className="me-2" />
                                    {errors.remark}
                                </p>
                            )}
                        </Form.Group>
                    </Col>
                </Row>

                {/* Assign To / Department / Sub Department */}
                {/* <Row className="mb-4">
                    <Col md={4}>
                        <Form.Label className="fw-bold">
                            Assign To
                        </Form.Label>
                        <Form.Control
                            value={data?.resourceName || ""}
                            disabled
                            style={{ backgroundColor: "#f5f5f5" }}
                        />
                    </Col>

                    <Col md={4}>
                        <Form.Label className="fw-bold">
                            Department Name
                        </Form.Label>
                        <Form.Control
                            value={data?.departmentName || ""}
                            disabled
                            style={{ backgroundColor: "#f5f5f5" }}
                        />
                    </Col>

                    <Col md={4}>
                        <Form.Label className="fw-bold">
                            Sub Department Name
                        </Form.Label>
                        <Form.Control
                            value={data?.subDepartmentName || ""}
                            disabled
                            style={{ backgroundColor: "#f5f5f5" }}
                        />
                    </Col>
                </Row> */}

                {/* Task Title / Priority */}
                {/* <Row className="mb-4">
                    <Col md={6}>
                        <Form.Label className="fw-bold">
                            Task Title
                        </Form.Label>
                        <Form.Control
                            value={data?.taskName || ""}
                            disabled
                            style={{ backgroundColor: "#f5f5f5" }}
                        />
                    </Col>

                    <Col md={6}>
                        <Form.Label className="fw-bold">
                            Task Priority
                        </Form.Label>
                        <Form.Control
                            value={data?.taskPriority || ""}
                            disabled
                            style={{ backgroundColor: "#f5f5f5" }}
                        />
                    </Col>
                </Row> */}

                {/* Task Description */}
                {/* <Row className="mb-4">
                    <Col md={12}>
                        <Form.Label className="fw-bold">
                            Task Description
                        </Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={data?.taskDescription || ""}
                            disabled
                            style={{ backgroundColor: "#f5f5f5" }}
                        />
                    </Col>

                </Row> */}

                {/* Project Name */}
                {/* <Row className="mb-4">
                    <Col md={12}>
                        <Form.Label className="fw-bold">
                            Project Name
                        </Form.Label>
                        <Form.Control
                            value={data?.projectName || ""}
                            disabled
                            style={{ backgroundColor: "#f5f5f5" }}
                        />
                    </Col>

                </Row> */}

                {/* Editable Fields */}
                <Row className="mb-4">
                    <Col md={3}>
                        <Form.Label className="fw-bold">
                            Proposed Start Date <span className="requiredfield">*</span>
                        </Form.Label>
                        <Form.Control
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                        />
                        {errors.startDate && (
                            <p className="errMsg">
                                <Icon.ExclamationTriangle className="me-2" />
                                {errors.startDate}
                            </p>
                        )}
                    </Col>

                    <Col md={3}>
                        <Form.Label className="fw-bold">
                            Proposed End Date <span className="requiredfield">*</span>
                        </Form.Label>
                        <Form.Control
                            type="date"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                        />
                        {errors.endDate && (
                            <p className="errMsg">
                                <Icon.ExclamationTriangle className="me-2" />
                                {errors.endDate}
                            </p>
                        )}
                    </Col>

                    <Col md={3}>
                        <Form.Label className="fw-bold">
                            Initial Estimate(Hours) <span className="requiredfield">*</span>
                        </Form.Label>
                        <Form.Control
                            value={hours}
                            onChange={(e) => {

                                if (
                                    /^[0-9]*(\.[0-9]*)?$/.test(e.target.value)
                                ) {
                                    setHours(e.target.value);
                                }
                            }}
                            placeholder="Hours"
                        />
                        {errors.hours && (
                            <p className="errMsg">
                                <Icon.ExclamationTriangle className="me-2" />
                                {errors.hours}
                            </p>
                        )}
                    </Col>

                    <Col md={3}>
                        <Form.Label className="fw-bold">
                            Initial Minutes <span className="requiredfield">*</span>
                        </Form.Label>
                        <Form.Control
                            value={minutes}
                            onChange={(e) => {
                                if (
                                    /^[0-9]{0,2}$/.test(e.target.value) &&
                                    e.target.value >= 0 &&
                                    e.target.value <= 59
                                ) {
                                    setMinutes(e.target.value);
                                }
                            }}
                            placeholder="Minutes"
                        />
                        {errors.minutes && (
                            <p className="errMsg">
                                <Icon.ExclamationTriangle className="me-2" />
                                {errors.minutes}
                            </p>
                        )}
                    </Col>
                </Row>
            </Modal.Body>

            <Modal.Footer>
                <Button className="primaryBtn" onClick={handleSubmit}>
                    Reopen Task
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ReopenTaskModal;